<script setup lang="ts">
import { BASE_TITLE } from '~/utilities/constants';

useHead({
  title: `Legal Notice ${BASE_TITLE}`,
});
</script>
<template>
  <Container>
    <div class="py-8 sm:py-16">
      <div class="mx-auto max-w-3xl text-base leading-7 text-neutral-700 dark:text-neutral-200">
        <h1 class="mt-2 text-3xl font-bold tracking-tight text-neutral-900 dark:text-neutral-50 sm:text-4xl">
          Legal Notice
        </h1>
        <div class="mt-10 max-w-2xl">
          <p>MintGarden GmbH<br />Feldstr. 15a<br />84405 Dorfen<br />Germany</p>
          <p class="mt-4">Managing Director: Andreas Greimel</p>
          <p>E-Mail: <a href="mailto:contact@mintgarden.io">contact@mintgarden.io</a></p>
          <p>Trade Register: HRB 286511, Munich District Court</p>
          <p>European VAT ID#: DE362575354</p>

          <p class="mt-4">This Legal Notice (Impressum) complies with the German laws under § 5 TMG and § 55 RStV.</p>
          <p class="mt-4">Donation address: xch1kshxpng3srn22e94mktz6l3jx3kptkmypvsjqwxsxk0k0ex8fxuqmxalgm</p>

          <h2 class="mt-8 text-xl font-bold tracking-tight text-neutral-900 dark:text-neutral-50">
            Online Dispute Resolution website of the EU Commission
          </h2>
          <p>
            In order for consumers and traders to resolve a dispute out-of-court, the European Commission developed the
            Online Dispute Resolution Website:
            <NuxtLink
              class="text-emerald-600 hover:text-emerald-500"
              href="https://www.ec.europa.eu/consumers/odr"
              target="_blank"
              >www.ec.europa.eu/consumers/odr</NuxtLink
            >
          </p>

          <h2 class="mt-4 text-xl font-bold tracking-tight text-neutral-900 dark:text-neutral-50">Legal disclaimer</h2>
          <p>
            The contents of these pages were prepared with utmost care. Nonetheless, we cannot assume liability for the
            timeless accuracy and completeness of the information.
          </p>

          <p>
            Our website contains links to external websites. As the contents of these third-party websites are beyond
            our control, we cannot accept liability for them. Responsibility for the contents of the linked pages is
            always held by the provider or operator of the pages.
          </p>

          <h2 class="mt-4 text-xl font-bold tracking-tight text-neutral-900 dark:text-neutral-50">Data protection</h2>
          <p>
            In general, when visiting this website, no personal data are saved. However, these data can be given on a
            voluntary basis. No data will be passed on to third parties without your consent. We point out that in
            regard to unsecured data transmission in the internet (e.g. via email), security cannot be guaranteed. Such
            data could possibIy be accessed by third parties.
          </p>
        </div>
      </div>
    </div>
  </Container>
</template>
